import { useQuery } from '@tanstack/react-query';

import { authStorage } from '@ajaibid/utils';
import fetch from './fetch';

function useUserData() {
  const cacheUserData = authStorage.get('userData');

  const { cb, key } = fetch();
  const { data, isLoading, isSuccess, isError, refetch } = useQuery(key, cb, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    cacheTime: Infinity,
  });

  if (data) {
    authStorage.set('userData', data);
  }

  const userData = data || cacheUserData;

  return { userData, isLoading, isSuccess, isError, refetch };
}

export { useUserData };
export default { useUserData };
